import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["points", "activePoint", "onPointClick", "className", "dotClassName", "activeDotClassName", "size", "direction"];
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { forwardRef, useMemo } from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var cnPagination = cnBem('pagination', styles);
export var Pagination = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$points = props.points,
    poinstProp = _props$points === void 0 ? 1 : _props$points,
    activePoint = props.activePoint,
    onPointClick = props.onPointClick,
    className = props.className,
    dotClassName = props.dotClassName,
    activeDotClassName = props.activeDotClassName,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'column' : _props$direction,
    otherProps = _objectWithoutProperties(props, _excluded);
  var points = useMemo(function () {
    return new Array(Math.max(poinstProp, 1)).fill(null);
  }, [poinstProp]);
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cnPagination({
      direction: direction,
      size: size
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "components-Pagination"
  }), points.map(function (_, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: cnPagination('item', {
        i: i
      })
    }, /*#__PURE__*/React.createElement("button", {
      "aria-label": "\u041F\u0443\u043D\u043A\u0442 ".concat(i + 1),
      className: cnPagination('dot', {
        active: i + 1 === activePoint,
        direction: direction
      }, [dotClassName, i + 1 === activePoint ? activeDotClassName : undefined]),
      onClick: function onClick(e) {
        return onPointClick === null || onPointClick === void 0 ? void 0 : onPointClick(i + 1, e);
      },
      type: "button"
    }));
  }));
});